module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/trolley-034e3877cf7ccb39576c8ff52dcbbdd3.png";